import { Node } from "@tiptap/core";

const MultipleCitationsNode = Node.create({
  name: "multipleCitations",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      citationString: {
        default: "",
      },
      qid: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "multipleCitations",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["multipleCitations", HTMLAttributes];
  },

  addNodeView() {
    return ({
      editor,
      node,
      getPos,
      HTMLAttributes,
      decorations,
      extension,
    }) => {
      const dom = document.createElement("span");
      /**
       * sample node.attrs = {
            "citationString": "3101.1, 3101.2, 3101.3, 3101.4, 3101.5, 3101.6, 3101.7, 3101.8",
            "qid": "2d9fb816-b26c-496e-bf8a-c20c6b275c3e"
        }
       */

      dom.className =
        "node-citation rounded-full mr-1 bg-gray-400 text-gray-100 text-[8px] p-0.5 px-1 cursor-pointer align-top h-fit";
      dom.innerHTML = "Sources";
      dom.onclick = (e) => {
        if ((window as any).handleReferenceClick) {
          (window as any).handleReferenceClick(e as any, {
            qid: node.attrs.qid,
            multipleCitations: node.attrs.citationString,
          });
        }
      };

      return {
        dom,
      };
    };
  },
});

export default MultipleCitationsNode;
